import { PRIORITY_TYPE } from '@atlassian/jira-platform-field-config';
import type { StringValue, RichValue } from '../../../value/types';
import type { TransformedPriority, TransformedPriorityField } from '../types';

const getPriorityValue: StringValue<TransformedPriorityField> = (field) => field.value?.name || '';

export const priorityStringValueHandler = {
	[PRIORITY_TYPE]: getPriorityValue,
};

const getPriorityRichValue: RichValue<TransformedPriorityField, TransformedPriority> = (field) =>
	field.value || null;

export const priorityRichValueHandler = {
	[PRIORITY_TYPE]: getPriorityRichValue,
};
